import { useMemo } from "react";
import useMeasure from "react-use-measure";
import { HEIGHT_TABLE_HEADER } from "../../../documentSet/constants";
import {
  HEIGHT_PAGINATION,
  HEIGHT_TITLE_HEADER,
  PAGE_PADDING,
} from "../../../userManagement/constants";

export enum TableType {
  USER_MANAGEMENT,
  STP,
  EMAIL_TEMPLATES,
  RELEASES,
  MASTER_DATA,
  CONFIG_MAP,
}

const useTableDynamicHeight = (tableType: TableType) => {
  const [refHeightContainer, { height: heightContainer }] = useMeasure();

  const heightTableContent = useMemo(() => {
    let height: number;

    if (tableType === TableType.MASTER_DATA) {
      height =
        heightContainer -
        HEIGHT_TABLE_HEADER -
        HEIGHT_TITLE_HEADER -
        HEIGHT_PAGINATION -
        PAGE_PADDING;
    } else if (
      tableType === TableType.USER_MANAGEMENT ||
      tableType === TableType.STP
    ) {
      height =
        heightContainer -
        HEIGHT_TABLE_HEADER -
        HEIGHT_TITLE_HEADER -
        PAGE_PADDING;
    } else if (tableType === TableType.CONFIG_MAP) {
      height =
        heightContainer -
        HEIGHT_TABLE_HEADER -
        HEIGHT_TITLE_HEADER -
        PAGE_PADDING;
    } else {
      height = heightContainer - HEIGHT_TABLE_HEADER;
    }

    // Ensure minimum height to prevent layout shift when table header becomes fixed
    return Math.max(height, 200);
  }, [heightContainer, tableType]);

  return {
    refHeightContainer,
    heightTableContent,
  };
};

export default useTableDynamicHeight;
